import { ErrorMessage } from '@/messages/error';
import type { ActionPointFile, Base64WithMetaData } from '@/types/files';
import { callApi } from '@/utils/api';
import { handleAxiosError } from '@/utils/error';
import { encodePath } from '@/utils/file';
import { defineStore } from 'pinia';

export const useFileStore = defineStore('file', () => {
    async function getFile(organizationId: string, filePath: string): Promise<Base64WithMetaData> {
        try {
            const encodedPath = encodePath(filePath);
            const data = await callApi<Base64WithMetaData>({
                method: 'GET',
                endpoint: `files/${organizationId}/${encodedPath}`
            });

            return data;
        } catch (error) {
            return handleAxiosError(error, [], ErrorMessage.FILE_CANT_DOWNLOAD);
        }
    }

    async function getActionPointFiles(organizationId: string, actionPointId: string): Promise<ActionPointFile[]> {
        try {
            const files = await callApi<ActionPointFile[]>({
                method: 'GET',
                endpoint: `files/actionPoint/${organizationId}/${actionPointId}`
            });
            return files;
        } catch (error) {
            return handleAxiosError(error, [], ErrorMessage.FILES_CANT_LOAD);
        }
    }

    async function getDirectoryContent(organizationId: string, directoryPath: string): Promise<Base64WithMetaData[]> {
        try {
            const encodedPath = encodePath(directoryPath);
            const result = await callApi({
                method: 'GET',
                endpoint: `files/directory/${organizationId}/${encodedPath}`
            });

            return result.object as Base64WithMetaData[];
        } catch (error) {
            return handleAxiosError(error, [], ErrorMessage.DIRECTORY_CANT_LOAD);
        }
    }

    return {
        getFile,
        getActionPointFiles,
        getDirectoryContent
    };
});
